window.subscriptionListener = function (object = null) {
    let hiddenInput = (object == null) ? document.querySelector('#subscription_data') : object.querySelector('#subscription_data');
    if (hiddenInput.dataset.hasSubscription == 'true') {
        let priceElement = (object == null) ? document.querySelectorAll('.rca-product-price') : object.querySelectorAll('.rca-product-price');
        let rechargeInterval = setInterval(function () {
            let widget = (object == null) ? document.querySelector('.rc-widget') : object.querySelector('.rc-widget');
            if (widget != null) {
                // Ensure the "One Time" option is selected by default
                let oneTimeOption = widget.querySelector('[name="purchaseOption"][value="onetime"]');
                let subscriptionOption = widget.querySelector('[name="purchaseOption"][value="subscription"]');
                
                if (oneTimeOption && subscriptionOption) {
                    console.log('Setting "One Time" option as checked');
                    oneTimeOption.checked = true; // Ensure "One Time" button is checked by default
                    subscriptionOption.checked = false; // Ensure "Subscribe" button is unchecked
                    console.log('One Time checked:', oneTimeOption.checked);
                    console.log('Subscription checked:', subscriptionOption.checked);
                }

                let checkedValue = widget.querySelector('[name="purchaseOption"]:checked');
                updatePrice(checkedValue);

                widget.querySelectorAll('[name="purchaseOption"]').forEach(function (element) {
                    element.addEventListener('click', function () {
                        updatePrice(this);
                    });
                });

                function updatePrice(element) {
                    if (element.value == 'subscription') {
                        priceElement.forEach((element) => {
                            element.innerHTML = `${hiddenInput.dataset.subscriptionPrice} <del>${hiddenInput.dataset.originalPrice}</del>`;
                        });
                    } else {
                        // One-time purchase - check for Boxing Day sale
                        let isBoxingDay = hiddenInput.dataset.boxingDaySale === 'true';
                        let salePrice = hiddenInput.dataset.salePrice;
                        if (isBoxingDay && salePrice) {
                            priceElement.forEach((element) => {
                                element.innerHTML = `${salePrice} <del>${hiddenInput.dataset.originalPrice}</del>`;
                            });
                        } else {
                            priceElement.forEach((element) => {
                                element.innerHTML = `${hiddenInput.dataset.originalPrice}`;
                            });
                        }
                    }
                }
                clearInterval(rechargeInterval);
            }
        }, 100);
    }
};

document.addEventListener('DOMContentLoaded', function() {
    if (document.body.classList.contains('template-name--product')) {
        window.subscriptionListener();
    }
});


//on scroll add class add and remove
if (document.querySelector('.product__description') && document.getElementById('js-addClass')) {
    const navbar = document.getElementById('js-addClass');
    const description = document.querySelector('.product__description').scrollHeight;
    const onScroll = () => {
        const scroll = document.documentElement.scrollTop
        if (scroll > 100) {
            navbar.classList.add("scrolled");
        }
        if (scroll > `description + 100`) {
            navbar.classList.remove("scrolled")
        }
    }
    window.addEventListener('scroll', onScroll)
}

if (document.body.classList.contains('template-name--product')) {
    window.subscriptionListener();
}

// image text link slider

if (document.querySelector('.image_text_slider')) {
    let image_text_slider = document.querySelector('.image_text_slider');
    let flkty = new Flickity(image_text_slider, {
        cellAlign: 'left',
        wrapAround: false,
        contain: true,
        prevNextButtons: false,
        pageDots: false
    });
    let previousButton = document.querySelector('.button--previous');
    previousButton.addEventListener('click', function () {
        flkty.previous(true);
    });
    let nextButton = document.querySelector('.button--next');
    nextButton.addEventListener('click', function () {
        flkty.next(true);
    });
}

// featured collection new silder
if (document.querySelectorAll('.featured_collection_slider').length) {
    let contain = false;
    let groupcells = 1;
    if (matchMedia('screen and (min-width: 990px)').matches) {
        contain = true;
        groupcells = 3;
    }
    if (matchMedia('screen and (max-width: 989px)').matches) {
        contain = false;
        groupcells = 1;
    }
    let featured_collection_slider = document.querySelectorAll('.featured_collection_slider');
    featured_collection_slider.forEach(function (element) {

        let previousButton = element.closest('.shopify-section').querySelector('.btn--previous');
        let nextButton = element.closest('.shopify-section').querySelector('.btn--next');

        let FlickityOptions = {
            cellAlign: 'left',
            wrapAround: false,
            contain: contain,
            prevNextButtons: true,
            adaptiveHeight: false,
            pageDots: false,
            groupCells: groupcells,
            arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 60,
                y2: 45,
                x3: 15
            }
        }

        FlickityOptions['on'] = {
            scroll: function (progress) {
                if (FlickityOptions['wrapAround'] == true) {
                    return;
                }
                if (previousButton && nextButton) {
                    if (progress <= 0) {
                        previousButton.classList.add('disabled');
                        previousButton.setAttribute('disabled', true);
                        nextButton.classList.remove('disabled');
                        nextButton.removeAttribute('disabled');
                    } else if (progress > 0 && progress < 1) {
                        previousButton.classList.remove('disabled');
                        previousButton.removeAttribute('disabled');
                        nextButton.classList.remove('disabled');
                        nextButton.removeAttribute('disabled');
                    } else {
                        nextButton.classList.add('disabled');
                        nextButton.setAttribute('disabled', true);
                        previousButton.classList.remove('disabled');
                        previousButton.removeAttribute('disabled');
                    }
                }
            }
        }

        if (element.dataset.customFlikityOptions) {
            let customFlikityOptions = JSON.parse(element.dataset.customFlikityOptions);
            for (option in customFlikityOptions) {
                FlickityOptions[option] = customFlikityOptions[option];
            }
            //console.log(FlickityOptions)
        }


        let flkty_slider = new Flickity(element, FlickityOptions);
        /*setTimeout(() => {
          flkty_slider.reposition()
        }, 500);*/

        if (previousButton) {
            previousButton.addEventListener('click', function () {
                flkty_slider.previous(true);
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', function () {
                flkty_slider.next(true);
            });
        }
    });
}

window.setGridHeight('.product_info .product_content .tag_wrap');
//window.setGridHeight('.card__information .card__title_wrap .card__heading');
window.setGridHeight('.blog_item_wrap.item_third .blog_content .content_wrap .blog_title');
window.setGridHeight('.blog_item_wrap.item_third .blog_content .content_wrap .blog_desc');
window.setGridHeight('.circle_content_wrap .content_wrap .step_count');
window.setGridHeight('.circle_content_wrap .content_wrap .sub_text');
window.setGridHeight('.slider_wrap .slider_item_wrap .slider_item .process_content');
window.setGridHeight('.featured_collection_slider .flickity-slider .slider__slide .card-wrapper .card--media');
window.setGridHeight('.featured_collection_slider .flickity-slider .slider__slide .card-wrapper .card--media .card_content_wrap');
window.setGridHeight('.collection_grid_wrap .card-wrapper .card--media .card_content_wrap');
// Load More Functionality

let loadMoreContainer = document.querySelectorAll('.js-load-more-functionality');
let mobileDevice = window.matchMedia('(max-width:749px)');

loadMoreContainer.forEach(function (element) {
    if (!element.hasAttribute('data-show-grids')) {
        return;
    }
    let showGrids = parseInt(element.dataset.showGrids),
        productGrids = element.querySelectorAll('.grid__item');

    function _hideGrids() {
        for (let index = showGrids; index < productGrids.length; index++) {
            productGrids[index].classList.add('hidden');
        }
    }

    function _showGrids() {
        for (let index = showGrids; index < productGrids.length; index++) {
            productGrids[index].classList.remove('hidden');
        }
    }

    (mobileDevice.matches == true) ? _hideGrids() : _showGrids();
    mobileDevice.onchange = function (actions) {
        (actions.matches == true) ? _hideGrids() : _showGrids();
    }

    let loadMoreButton = element.closest('.js-load-more-grids--wrapper').querySelector('.js-load-more-btn');
    loadMoreButton.addEventListener('click', function () {
        _showGrids();
        this.parentElement.style.display = 'none';
    });
});


// Testimonial silder
if (document.querySelector('.testimonial_slider')) {
    let testimonial_slider = document.querySelector('.testimonial_slider');
    let flkty = new Flickity(testimonial_slider, {
        cellAlign: 'left',
        wrapAround: false,
        contain: true,
        fade: true,
        prevNextButtons: false,
        pageDots: false,
        on: {
            change: function (index) {
                new Flickity('.text_slider').select(index);
            }
        }
    });
}

let text_slider = document.querySelector('.text_slider');
if (text_slider) {
    let flkty = new Flickity(text_slider, {
        cellAlign: 'left',
        wrapAround: true,
        contain: true,
        prevNextButtons: true,
        pageDots: true,
        fade: false,
        arrowShape: 'M0,50L44.9,5l9.5,9.5L25.6,43.3H100v13.4H25.6l28.8,28.8L44.9,95L0,50z',
        on: {
            ready: function () {
                text_slider.querySelectorAll('.flickity-page-dots .dot').forEach(function (element, index) {
                    element.innerText = index + 1;
                })
            },
            change: function (index) {
                new Flickity('.testimonial_slider').select(index);
            }
        }
    });
}


// Product Image silder -- Product page
let product_img_slider = document.querySelector('.product_img_slider');
if (product_img_slider) {
    let flkty = new Flickity(product_img_slider, {
        cellAlign: 'center',
        wrapAround: true,
        contain: true,
        fade: true,
        adaptiveHeight: true,
        prevNextButtons: false,
        pageDots: true,
      adaptiveHeight: true
    });
}


// Process Image silder -- Home page
let process_img_slider = document.querySelector('.process_img_slider');
if (process_img_slider) {
    let flkty = new Flickity(process_img_slider, {
        cellAlign: 'center',
        wrapAround: true,
        contain: true,
        fade: true,
        prevNextButtons: false,
        pageDots: true
    });
}

let process_content_slider = document.querySelector('.process_content_slider');
if (document.querySelector('.process_content_slider')) {
    let flkty = new Flickity(process_content_slider, {
        cellAlign: 'center',
        wrapAround: true,
        contain: true,
        fade: true,
        prevNextButtons: false,
        pageDots: false,
        asNavFor: '.process_img_slider'
    });
}



// combine and save slider
if (document.querySelector('.combine_save_slider')) {
    const combine_save_slider = document.querySelector('.combine_save_slider');
    const initSlider = () => {
        let flkty = new Flickity(combine_save_slider, {
            cellAlign: 'left',
            wrapAround: true,
            contain: true,
            prevNextButtons: true,
            pageDots: false,
            arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 60,
                y2: 45,
                x3: 15
            }
        });
    };
    const combineAndSaveSlider = () => {
        let sliderItemCount = document.querySelectorAll(".product_item").length;
        let windowWidth = window.innerWidth;
        if (windowWidth <= 749 && sliderItemCount > 1) {
            initSlider();
        }
        if (windowWidth > 749 && sliderItemCount > 2) {
            initSlider();
        }
    }
    window.addEventListener("resize", function () {
        combineAndSaveSlider();
    });
}

if (document.querySelectorAll('.js-popup').length) {
    document.querySelectorAll('.js-popup').forEach(function (element) {
        let cookeyName = element.dataset.cookeyName;
        let savedCookey = window.getCookie(cookeyName) || null;
        if (savedCookey == null) {
            element.classList.remove('hidden');
        }
    });
}

(function () {
    let slideIndex = 0;
    document.querySelectorAll(".js-slider-item").forEach((element) => {
        console.log(element);
        console.log(element.offsetTop);
        window[`slider-${slideIndex}`] = element.offsetTop + element.offsetHeight;
        console.log(window);
        slideIndex++;
    });
    let sliderDotsElements = document.querySelectorAll(".js-slider-button");

    sliderDotsElements.forEach(function (sliderDotsElement) {
        sliderDotsElement.addEventListener("click", _slideItem.bind(this), true)
    });

    function _slideItem({ currentTarget }) {
        function getHighestHeightOfElement() {
            let highestClientHeight = 0;
            highestClientHeight = [...document.querySelectorAll(".js-slider-item")].map((sliderItem) => {
                if (sliderItem.offsetHeight > highestClientHeight) {
                    highestClientHeight = sliderItem.offsetHeight
                }
                return highestClientHeight;
            });
            highestClientHeight = Math.max(...highestClientHeight);
            return highestClientHeight;
        }
        let prevDotIndex = parseInt(document.querySelector(".js-slider-button.active").getAttribute("data-index"));
        document.querySelectorAll(".js-slider-button").forEach((dot) => {
            dot.classList.remove("active")
        });
        currentTarget.classList.add("active");

        let firstTop = parseInt(document.querySelector("#slide_0").getBoundingClientRect().top);
        let nextDotIndex = parseInt(currentTarget.getAttribute("data-index"));      
        let nextOfActive = prevDotIndex + 1;
        if(prevDotIndex == 5){ nextOfActive = prevDotIndex }
        let nextSlideTop = parseInt(document.querySelectorAll(".js-slider-item")[nextDotIndex].getBoundingClientRect().top);
        let diff = nextDotIndex - prevDotIndex;
        let scrollDistance;
        if (diff > 0) {
            scrollDistance = parseInt(nextSlideTop - firstTop);
        } else {

            var prevIndex = parseInt(document.querySelector(".js-slider-button.active").getAttribute("data-index")) + 1;
            var prevIndexTop = parseInt(document.querySelectorAll(".js-slider-item")[prevIndex].getBoundingClientRect().top);
            var prevTopfromFirst = parseInt(prevIndexTop - firstTop);
            var remain_scrolled =  parseInt(getHighestHeightOfElement() - prevTopfromFirst);

            var nextActiveTop = parseInt(document.querySelectorAll(".js-slider-item")[nextOfActive].getBoundingClientRect().top);
            var TopfromFirst = parseInt(nextActiveTop - firstTop);
            //scrollDistance = (getHighestHeightOfElement() * diff) - TopfromFirst;
            
            scrollDistance =  parseInt(TopfromFirst * diff)
            
            if(TopfromFirst < getHighestHeightOfElement() ){ console.log("scrolled:"+TopfromFirst)
              scrollDistance =  - (parseInt(getHighestHeightOfElement() - TopfromFirst) - (getHighestHeightOfElement() * diff))
            }
            if(prevDotIndex == 5){
              scrollDistance =  parseInt(getHighestHeightOfElement() * diff)
            }

        }

        console.log({
            //ActiveIndex : ActiveIndex,
            //nextOfActiveTop : nextOfActiveTop,
            height : getHighestHeightOfElement(),
            prevTopfromFirst : prevTopfromFirst,
            remain_scrolled : remain_scrolled,
            nextActiveTop : nextActiveTop,
            nextDotIndex: nextDotIndex,
            prevDotIndex: prevDotIndex,
            //nextOfPrev: nextOfPrev,
            //nextOfPrevTop: nextOfPrevTop,
            //prevTop: prevTop,
            nextSlideTop: nextSlideTop,
            diff : diff,
            TopfromFirst : TopfromFirst,

        })
        console.log("scrollDistance > "+ scrollDistance);


      
        window.scrollBy({ top: scrollDistance, left: 0, behavior: "smooth" });
    }

    window.addEventListener("scroll", function () {
        if (document.querySelector("#slide_1")) {
            let firstTop = parseInt(document.querySelector("#slide_0").getBoundingClientRect().top);
            document.querySelectorAll(".js-slider-item").forEach((element, index) => {
                if (parseInt(element.getBoundingClientRect().top) === firstTop) {
                    document.querySelectorAll(".js-slider-button").forEach((TempElement) => {
                        TempElement.classList.remove("active");
                    });
                    document.querySelector(`.js-slider-button[data-index='${index}']`).classList.add("active");
                }
            });
        }
    });


    window.changePrice = function (parent, letiantId, selectedElement) {
        let priceCheck = parent.querySelector('.js-product-form__input > input');

        let priceElement = parent.querySelector('.js-price');
        let gridAddtoCartBtn = parent.querySelector('.js-addCart');
        let letiantSellingObject = JSON.parse(parent.querySelector('script').innerHTML);
        let sellingPlanElement = parent.querySelector('[name="selling_plan"]');
        let singleletiantPchange = parent.querySelector('.selected'); {
            if (parent.querySelector(".js--subscription-btn.selected").classList.contains("is-subscripton-btn")) {
                parent.querySelector('.price__regular .price-item--regular').innerHTML = `${singleletiantPchange.getAttribute('data-price')} <del> ${singleletiantPchange.getAttribute('data-og-price')} </del>`;
                sellingPlanElement.value = singleletiantPchange.getAttribute('data-subscripiotn-id');
            } else {
                parent.querySelector('.price__regular .price-item--regular').innerHTML = `${singleletiantPchange.getAttribute('data-price')}`;
                sellingPlanElement.value = "";
            }
        }

        // Change price
        let objectLoop = Object.keys(letiantSellingObject);
        objectLoop.forEach(function eachKey(key) {
            if (key == letiantId) {

                let letiantSubscriptionPrice = letiantSellingObject[key].sellingPlan;
                let letiantSubscriptionOgPrice = letiantSellingObject[key].original_price;
                priceElement.innerHTML = `${letiantSubscriptionPrice}  <del> ${letiantSubscriptionOgPrice} </del>`;
                let letiantAvailable = letiantSellingObject[key].letiant_available;


                if (selectedElement) {
                    if (selectedElement.classList.contains('is-subscripton-btn')) {
                        sellingPlanElement.removeAttribute('disabled');
                        parent.querySelector('.price__regular .price-item--regular').innerHTML = `${letiantSubscriptionPrice} <del> ${letiantSubscriptionOgPrice} </del>`;
                    } else {
                        sellingPlanElement.setAttribute('disabled', true);
                        parent.querySelector('.price__regular .price-item--regular').innerHTML = `${letiantSubscriptionOgPrice}`;
                    }
                } else {
                    if (parent.querySelector(".js--subscription-btn.selected").classList.contains("is-subscripton-btn")) {
                        parent.querySelector('.price__regular .price-item--regular').innerHTML = `${letiantSubscriptionPrice} <del> ${letiantSubscriptionOgPrice} </del>`;
                        // sellingPlanElement.value = singleletiantPchange.getAttribute('data-subscripiotn-id');
                    } else {
                        parent.querySelector('.price__regular .price-item--regular').innerHTML = `${letiantSubscriptionOgPrice}`;
                        // sellingPlanElement.value = "";
                    }
                }
                // CTA button text change
                if (letiantAvailable == false) {
                    gridAddtoCartBtn.innerText = 'Sold Out';
                    gridAddtoCartBtn.classList.add('letiantSoldOut');
                    gridAddtoCartBtn.setAttribute("disabled", "");
                    console.log(gridAddtoCartBtn)
                } else {
                    gridAddtoCartBtn.innerText = 'Add to cart';
                    gridAddtoCartBtn.removeAttribute("disabled", "");
                }
            }
        });
    }

    let ulBreak = document.querySelectorAll('.js-breck-ul');
    ulBreak.forEach(function (e) {
        let liLength = e.querySelectorAll('li').length;
        if (liLength > 7) {
            e.classList.add('breck-ul')
        }
    });


    /*-- Collection Page Grid CTA Event --*/
    let customletiants = document.querySelectorAll('.js-product-form__input');
    customletiants.forEach(function (customletiant) {
        customletiant.querySelector("input").addEventListener("change", inputChangeEvent.bind(this), true);
    });

    function inputChangeEvent(e) {
        let parent = e.currentTarget.closest('.grid__item');
        let letiantId = e.currentTarget.value;
        let checkletiant = e.currentTarget.closest('.subscribe_btn_wrap');
        let directletiantAdd = checkletiant.querySelector('.directVariantAdd');
        directletiantAdd.value = letiantId;
        window.changePrice(parent, letiantId);
    }


  
})();



// window.changeButtonText = function() {
//     let subBtn = document.querySelectorAll('.js-subscripton-btn');
//     let quickBtn = document.querySelectorAll('.js-addCart');
//     let oneTimeBtn = document.querySelectorAll('.js-one-time-btn');
//     oneTimeBtn.forEach(function(e) {
//         e.addEventListener("click", function() {
//             let closeCheck = e.closest(".form");
//             //   let addCartOne = closeCheck.querySelector('.js-addCart').querySelector("span");
//             //   addCartOne.innerText = 'Add to cart';
//         });
//     });
//     subBtn.forEach(function(e) {
//         e.addEventListener("click", function() {
//             let closeCheck = e.closest(".form");
//             //   let addCartOne = closeCheck.querySelector('.js-addCart').querySelector("span");
//             //   addCartOne.innerText = 'Add to cart';
//         });
//     });
// }
// window.changeButtonText();